<template>
  <v-card height="100%" elevation="0" class="d-flex flex-column justify-center align-center">
    <v-card-title class="d-flex justify-center text-h2">
      {{ `${loggedInfo.user_name}，👋🏻 歡迎！` }}
    </v-card-title>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['loggedInfo']),
  },
  async mounted() {
    console.log('yo Home.vue')
    const query = new URLSearchParams(this.$route.query)
    if (query.has('line-group-token')) {
      return this.$router.push(`/bind-line-group?${query}`)
    }
  },
  methods: {},
}
</script>
